export const appRouterContainerId = 'appRouterContainer'
